export const InfoBoxFields = [
  {
    key: 'titleText',
    label: 'Title text',
  },
  {
    key: 'contentText',
    label: 'Content text',
  },
  {
    key: 'isAllowSubtext',
    label: 'Allow sub text',
  },
  {
    key: 'subText',
    label: 'Sub text',
  },
  {
    key: 'contentIcon',
    label: 'Icon',
  },
]
